import React from 'react'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import SimCardIcon from '@material-ui/icons/SimCard'

import useTariffCard from '../../hooks/useTariffCard'
import MainPriceOfCard from '../MainPriceOfCard/MainPriceOfCard'
import useTariffCardStyles from '../TariffCard/TariffCardStyles'
import TariffPriceAndDuration from '../TariffPriceAndDuration/TariffPriceAndDuration'

import { Price } from '~/basket/model/common/price.model'

interface TariffCard {
  id: string
  lineId: string
  selected: boolean
  top: boolean
  title: string
  minutes: number
  data: number
  prices: Price[]
  selectCard: (id: string) => void
  className?: string
  maxNumberOfPrices: number
}

export default function TariffCard({
  id,
  selected,
  lineId,
  top,
  title,
  minutes,
  data,
  prices,
  selectCard,
  className,
  maxNumberOfPrices,
}: TariffCard): React.ReactElement {
  const numberOfPrices = prices.length
  const classes = useTariffCardStyles({ maxNumberOfPrices, numberOfPrices })
  const { mainPrice, formattedBytes, formattedMinutes } = useTariffCard({
    data,
    minutes,
    prices,
  })

  return (
    <div className={`${classes.root} ${className}`} data-hook={`tariff-card-${id}-${lineId}`}>
      <Card
        className={
          selected ? `${classes.cardContainer} ${classes.selected}` : classes.cardContainer
        }
      >
        <div className={classes.iconContainer}>
          <SimCardIcon className={classes.icon} />
        </div>
        <div className={classes.topContainer}>
          {top && (
            <Typography className={classes.top} variant="caption" color="textSecondary">
              TOP
            </Typography>
          )}
        </div>
        <CardContent className={classes.content}>
          <Typography className={classes.title} variant="h6" color="textSecondary">
            {title}
          </Typography>
          <div className={classes.info}>
            <Typography component="p" variant="body2" color="textSecondary">
              minutos
            </Typography>
            <Typography component="p" variant="subtitle2">
              {formattedMinutes}
            </Typography>
          </div>
          <div className={classes.info}>
            <Typography component="p" variant="body2">
              datos
            </Typography>
            <Typography component="p" variant="subtitle2" color="textSecondary">
              {formattedBytes}
            </Typography>
          </div>
          <Box my={4}>
            <div className={classes.mainPrice}>
              <MainPriceOfCard price={mainPrice} isOnlyPrice={!prices.length} />
            </div>
            <div className={classes.otherPriceContainer}>
              {prices.map((price) => (
                <TariffPriceAndDuration
                  className={classes.secondPrice}
                  key={`tariff-card-price-${price.value}`}
                  price={price}
                />
              ))}
            </div>
          </Box>
        </CardContent>
        <CardActions className={classes.buttonContainer}>
          <Button
            size="small"
            variant="outlined"
            color="secondary"
            onClick={() => selectCard(id)}
            data-hook={`tariff-card-${id}-button-${lineId}`}
          >
            {selected ? 'seleccionada' : 'seleccionar'}
          </Button>
        </CardActions>
      </Card>
    </div>
  )
}
